import { createAction, handleActions } from "redux-actions";

import { createOmniPaginationObject } from "../../utils/helpers";

const actionScope = "SEARCH_SESSION_";

export const searchSessionRequestFail = createAction(actionScope + "ADMIN_SESSION_REQUEST_FAIL");

//#region Actions

export const searchPatientsRequest = createAction(actionScope + "SEARCH_PATIENTS_REQUEST");
export const searchPatientsSuccess = createAction(actionScope + "SEARCH_PATIENTS_SUCCESS");

export const searchPartnersRequest = createAction(actionScope + "SEARCH_PARTNERS_REQUEST");
export const searchPartnersSuccess = createAction(actionScope + "SEARCH_PARTNERS_SUCCESS");

export const searchProvidersRequest = createAction(actionScope + "SEARCH_PROVIDERS_REQUEST");
export const searchProvidersSuccess = createAction(actionScope + "SEARCH_PROVIDERS_SUCCESS");

//#endregion

//#region Search Invites
export const searchInvitesRequest = createAction(actionScope + "SEARCH_INVITES_REQUEST");
export const searchInvitesSuccess = createAction(actionScope + "SEARCH_INVITES_SUCCESS");

export const inviteSearchPagesSelector = state => state.searchSession.inviteSearchPages;
export const inviteSearchPaginationSelector = state => state.searchSession.inviteSearchPagination;
//#endregion

// initial state
const initialState = {
  patientSearchODMs: null,
  patientSearchInProgress: false,
  partnerSearchODMs: null,
  providerSearchODMs: null,

  //All Invites of any type
  inviteSearchODMs: null,
  inviteSearchPages: {},
  inviteSearchPageLoading: false,
  inviteSearchPagination: createOmniPaginationObject(null, 10),
};

// reducers
export default handleActions(
  {
    [searchSessionRequestFail]: (state, { payload }) => ({
      ...state,
      //clean up any state
      patientSearchInProgress: false,
      inviteSearchPageLoading: false,
    }),

    [searchPatientsRequest]: (state, { payload }) => ({
      ...state,
      patientSearchInProgress: true,
    }),

    [searchPatientsSuccess]: (state, { payload }) => ({
      ...state,
      patientSearchODMs: payload,
      patientSearchInProgress: false,
    }),

    [searchPartnersRequest]: state => state,
    [searchPartnersSuccess]: (state, { payload }) => ({
      ...state,
      partnerSearchODMs: payload,
    }),

    [searchProvidersRequest]: state => state,
    [searchProvidersSuccess]: (state, { payload }) => ({
      ...state,
      providerSearchODMs: payload,
    }),

    [searchInvitesRequest]: (state, { payload }) => ({
      ...state,
      inviteSearchPageLoading: true,
    }),
    [searchInvitesSuccess]: (state, { payload }) => ({
      ...state,
      inviteSearchPages: payload.pages,
      inviteSearchODMs: payload.items,
      inviteSearchPagination: payload.pagination,
      inviteSearchPageLoading: false,
    }),
  },
  initialState
);
